export default "__VITE_ASSET__086ad972__"